const ConfirmationModal = ({ confirmText, cancelText, onConfirm, onCancel, children }) => {
  return (
    <div className='fixed inset-0 z-50 bg-black bg-opacity-80 flex justify-center items-center' onClick={onCancel}>
      <div>
        {children}
        <div className='mt-8'>
          <button className='btn btn-error w-full mt-4 bg-opacity-80' onClick={onConfirm}>{confirmText}</button>
          <button className='btn btn-success w-full mt-4 bg-opacity-80' onClick={onCancel}>{cancelText}</button>
        </div>
      </div>
    </div>
  )
}

export { ConfirmationModal }
